<template>
  <div class="card">
    <div class="card-header">
      <div class="card-header-title">
        <strong>Feed #{{ playlistIndex }}</strong>
      </div>
    </div>
    <div class="card-body">
      <span v-if="playlistData.feed_name"><strong>Feed Name</strong> : {{ playlistData.feed_name }}<br></span>
      <span><strong>Mode (ordering)</strong> : <span class="text-capitalize">{{ playlistData.options.mode }}</span><br></span>
      <span><strong>Reload Mode</strong> : <span class="text-capitalize">{{ playlistData.options.reload_mode }}</span><br></span>
      <span><strong>Reload Interval</strong> : {{ playlistData.options.reload }}</span>
    </div>
    <div class="card-footer">
      <a v-if="user.is_super_admin" :href="playlistData.url"
         target="_blank"
         type="button"
         class="btn btn-ss">View PLS file</a>
      <a v-if="playlistData.feed_uuid" :href="`/feeds/${playlistData.feed_uuid}/edit`"
         target="_blank"
         type="button" class="btn btn-ss">View Feed</a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    playlistData: {
      type: Object,
      required: true,
    },
    playlistIndex: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      user: window.user,
    };
  },
};
</script>
